// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"6d4b8f00","314":"02303f12","500":"346b0157","608":"fdb5dbf5","681":"ddfc17bd","722":"7d87e166","786":"257220ba"}[chunkId] + ".chunk.js";
};